import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FylgibrefPrint from "../print/fylgibref/FylgibrefPrint";
import FylgibrefPreview from "../print/fylgibref/FylgibrefPreview";
import UmslagPrint from "../print/umslag/UmslagPrint";
import UmslagPreview from "../print/umslag/UmslagPreview";


const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  },
  icon: {
    marginRight: theme.spacing()
  }
}));

export default function PrintStep(props) {
  const classes = useStyles();
  const { formState, kjosandiInfo, activeKosning, handleNext, handleBack } = props;
  const { kjosandi } = kjosandiInfo;

  return (
    <Fragment>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="center"
          justify="center"
        >
          <Grid item>
            <FylgibrefPrint
              formState={formState}
              kjosandi={kjosandi}
              activeKosning={activeKosning}
            />
          </Grid>
          <Grid item>
            <UmslagPrint kjosandi={kjosandi} activeKosning={activeKosning} />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="center"
          justify="center"
          style={{ marginTop: "16px" }}
        >
          <Grid item>
            <FylgibrefPreview
              formState={formState}
              kjosandi={kjosandi}
              activeKosning={activeKosning}
            />
          </Grid>
          <Grid item>
            <UmslagPreview kjosandi={kjosandi} activeKosning={activeKosning} />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ marginTop: "32px" }}
        >
          <Grid item xs>
            <Typography color="textSecondary">
              <strong>Athugið að nauðsynlegt er að velja rétta blaðastærð við prentun</strong>
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography color="textSecondary">
              Fylgibréf skal prenta sem <em>A4</em> en umslag sem <em>Envelope B5</em>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Button onClick={handleBack}>Til baka</Button>
        </Grid>
        <Grid item>
          <Button color="primary" variant="contained" onClick={handleNext}>
            Áfram
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
}
